import { motion } from "framer-motion";
import MobileParallax from "@/components/oneyork/MobileParallax";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 lg:py-36 bg-[#0a0a0a]"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <MobileParallax intensity={70} dim={0.96} className="flex justify-center mb-10 lg:mb-14">
          <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          >
            <img
              data-testid="story-leo-portrait"
              src="/images/story.png"
              alt="Leo — Founder, ONE YORK Auto Detailing"
              className="w-44 sm:w-52 lg:w-60 aspect-square rounded-full object-cover"
              loading="lazy"
            />
          </motion.div>
        </MobileParallax>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.85 }}
          className="text-center"
        >
          <span className="text-xs uppercase tracking-[0.28em] text-[#d4af37] font-medium">
            How ONE YORK Came To Life
          </span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Leo{" "}
            <span className="italic font-medium text-white/70">
              The Author.
            </span>
          </h2>

          <div className="mt-10 space-y-6 text-white/75 leading-relaxed text-base sm:text-lg max-w-3xl mx-auto">
            <p>
              Before entering the detailing industry, the foundation was built
              in photography, branding, graphic design, and marketing.
              Understanding visual perception, presentation, and systems shaped
              a mindset centered on precision. Details influence value, and
              standards define results.
            </p>
            <p>
              That perspective later evolved into a structured partnership
              within the detailing field. It wasn’t just about cleaning
              vehicles, but building systems, refining workflow, elevating
              customer experience, and maintaining consistent quality. The
              experience strengthened both operational discipline and brand
              execution.
            </p>
            <p>
              ONE YORK is the next step, built independently with full creative
              and operational control. A focused mobile detailing brand designed
              for drivers who value time, professionalism, and attention to
              detail.
            </p>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10">
            <p className="font-display italic text-xl sm:text-2xl text-[#d4af37] tracking-tight">
              “Back to Brand New and Beyond.”
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
